import { render, staticRenderFns } from "./Artist.vue?vue&type=template&id=4eecd800&scoped=true&"
var script = {}
import style0 from "./Artist.vue?vue&type=style&index=0&id=4eecd800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eecd800",
  null
  
)

export default component.exports